<template>
  <figure :class="['manual-figure', `manual-figure-${asset}`]">
    <button
      v-if="!failed"
      type="button"
      class="image-link"
      :aria-label="`放大图片：${caption}`"
      @click="preview"
    >
      <img
        :src="image.src"
        :width="image.width"
        :height="image.height"
        :alt="caption"
        loading="lazy"
        decoding="async"
        @error="failed = true"
      >
      <span aria-hidden="true">放大</span>
    </button>
    <p v-else class="image-error" role="status">
      图片未能加载：{{ caption }}。请重新打开页面，文字步骤仍可阅读。
    </p>
    <figcaption>{{ caption }}</figcaption>
  </figure>
</template>

<script>
import images from './images'

export default {
  name: 'SleepManualImage',
  props: {
    asset: { type: String, required: true },
    caption: { type: String, required: true }
  },
  data () {
    return { failed: false }
  },
  computed: {
    image () { return images[this.asset] }
  },
  methods: {
    preview (event) {
      this.$emit('preview', {
        src: this.image.src,
        caption: this.caption,
        trigger: event.currentTarget
      })
    }
  }
}
</script>
